export const benefits = [
  {
    title: "Do the ordinary extraordinarily well",
    description: "Curiosity and growth are a guarantee here.",
    advantages: [
      "Work on some of the most exciting business problems",
      "Work in a culture-first organization",
      "Mentorship from experienced leadership, and no red tape!"
    ]
  },
  {
    title: "Enjoy the work day",
    description: "Spending quality time with your coworkers is a no-brainer.",
    advantages: [
      "Company-wide retreats",
      "Regular team events, like celebrating an Iftaar",
      "Regular happy hours"
    ]
  },
  {
    title: "People first",
    description: "We put our people first, every time.",
    advantages: [
      "401(k) plan",
      "Unlimited PTO",
      "Work from anywhere",
      "Learning stipend"
    ]
  }
];
